/* eslint-disable import/no-default-export */
import React, { lazy, Suspense } from 'react';
import classnames from 'classnames';
import { IconColor, IconName } from 'app/common/components/controls';
import { IconButton } from 'app/common/components/controls/button/button';
import preventDefault from 'app/gamma/src/util/prevent-default';
// eslint-disable-next-line @trello/less-matches-component, @trello/assets-alongside-implementation
import dialogStyles from 'app/gamma/src/components/overlays/dialog/dialog.less';
import styles from './ShortcutsOverlay.less';

// We're eagerly loading the shortcuts content, because this component is used
// as an overlay on any board route. The stand-alone page shares the
// "shortcuts" chunk, but loads it async-as-needed.
const ShortcutsPromise = import(/* webpackChunkName: "shortcuts" */ 'app/src/components/Shortcuts');
const Shortcuts = lazy(() => ShortcutsPromise);

interface ShortcutsOverlayProps {
  onClose: () => void;
}

export const ShortcutsOverlay: React.FunctionComponent<
  ShortcutsOverlayProps
> = ({ onClose }) => {
  /**
   * NOTE: not returning a Gamma overlay here, because this component is
   * rendered from Classic controller code (see other-routes.coffee)... if/when
   * we've consolidated the overlay implementations we can revisit this.
   */
  return (
    <Suspense fallback={null}>
      <div>
        <IconButton
          className={classnames([dialogStyles.closeButton, styles.closeButton])}
          icon={IconName.Close}
          color={IconColor.Dark}
          largeIcon
          onClick={preventDefault(() => {
            onClose();
          })}
        />
        <Shortcuts />
      </div>
    </Suspense>
  );
};
